// extracted by mini-css-extract-plugin
module.exports = {"signaturePad":"signaturePad--2N2yr","signatureHelper":"signatureHelper--3_xt5","clearButton":"clearButton--1xT79"};